module.exports = __webpack_public_path__ + "static/media/path0101.42a6ab66.jpg";